// extracted by mini-css-extract-plugin
export default {"container":"e1-z","heading":"f1-z","links":"g1-z","copy":"h1-z","subCopy":"i1-z","linksLeft":"j1-z","linksCenter":"k1-z","linksRight":"l1-z","link":"m1-z","onlyLink":"n1-z"};